import {ErrorCode} from '@/services/ErrorService/ErrorService.constants';
import {BonusActivationType} from '@/stores/BonusesStore/BonusesStore.constants';

import {HttpErrorProject} from '@specials/project-user';

import {CHARITY_ITEM_NAME} from '@/resources/statisticItems';
import {ProjectUserInfoData} from '@/services/ProjectAuthApi/types';

const MOCK_BONUS_NAME = '100% кэшбэк на квартиру в Москве, или в Питере';
const MOCK_BONUS_HOW_TO_USE =
  'Купите полис для путешественников в Тинькофф Страховании до 15 июня. Оплатите покупку своей картой Тинькофф. Задание зачтется автоматически в течение 24 часов после оплаты';
const MOCK_BONUS_DESCRIPTION = 'Чем больше билетов, тем больше шансов выиграть главный приз';

export const userInfoResponse: ProjectUserInfoData = {
  id: 'test_user1',
  ssoId: 'test_user1_sso_id',
  isJunior: false,
  isSubscribedToNotifications: true,
  isOnboardingFinished: false,
  isOpenedAllItems: false,
  energyValue: 1,
  nextEnergyIn: 20000,
  items: [
    {
      id: 'item6',
      label: 'hugeBenefit',
      userStatistics: [],
      bonuses: [],
      weight: 6,
    },
    {
      id: 'item8',
      label: CHARITY_ITEM_NAME,
      userStatistics: [],
      bonuses: [],
      weight: 1,
    },
    {
      id: 'item9',
      label: 'secMB',
      userStatistics: [],
      bonuses: [],
      weight: 1,
    },
    {
      id: 'item10',
      label: 'deposit',
      userStatistics: [],
      bonuses: [],
      weight: 1,
    },
  ],
  bonuses: [
    {
      id: 'bonus1',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      weight: 0,
      actionButton: null,
      activation: {
        type: BonusActivationType.Macamp,
      },
    },
    {
      id: 'bonus2',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: null,
      weight: 1,
      activation: {
        type: BonusActivationType.Target,
      },
    },
    {
      id: 'bonus3',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: {
        href: 'https://www.tbank.ru/',
        text: 'Перейти в сервис',
      },
      weight: 2,
      activation: {
        type: BonusActivationType.Macamp,
      },
    },
    {
      id: 'bonus4',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: {
        href: 'https://www.tbank.ru/',
        text: 'Получить скидку',
      },
      weight: 3,
      activation: {
        type: BonusActivationType.Target,
      },
    },
    {
      id: 'bonus5',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: {
        href: 'https://www.tbank.ru/',
        text: 'Получить скидку',
      },
      weight: 4,
      activation: {
        type: BonusActivationType.PromoCodeCommon,
      },
    },
    {
      id: 'bonus6',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: {
        href: 'https://www.tbank.ru/',
        text: 'Получить скидку',
      },
      weight: 5,
      activation: {
        type: BonusActivationType.PromoCodeCommon,
      },
    },
    {
      id: 'bonus7',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: {
        href: 'https://www.tbank.ru/',
        text: 'Получить скидку',
      },
      weight: 6,
      activation: {
        type: BonusActivationType.PromoCodePersonal,
      },
    },
    {
      id: 'bonus8',
      name: MOCK_BONUS_NAME,
      description: MOCK_BONUS_DESCRIPTION,
      howToUseDetails: MOCK_BONUS_HOW_TO_USE,
      actionButton: null,
      weight: 7,
      activation: {
        type: BonusActivationType.PromoCodeCommon,
      },
    },
  ],
  userItems: [
    {
      id: 'userItem1',
      itemId: 'item10',
      bonus: null,
      createdAt: '2024-11-19T09:57:04.874Z',
    },
    {
      id: 'userItem2',
      itemId: 'item9',
      bonus: null,
      createdAt: '2024-11-19T09:57:04.874Z',
    },
    {
      id: 'userItem3',
      itemId: 'item8',
      bonus: null,
      createdAt: '2024-11-19T09:57:04.874Z',
    },
    {
      id: 'userItem4',
      itemId: 'item6',
      bonus: null,
      createdAt: '2024-11-19T09:57:04.874Z',
    },
  ],
};

export const itemsWithStatistic = [
  {
    id: 'item1',
    label: 'auto',
    userStatistics: [
      {
        metricDesc: 'favorite_pets_shop',
        value: 'Дом Ласковых и Пушистых Хвостов',
        weight: 1,
      },
      {
        metricDesc: 'pets_total_spends',
        value: '150001.34',
        weight: 2,
      },
    ],
    bonuses: [
      {
        id: 'bonus3',
        weight: 1,
      },
      {
        id: 'bonus4',
        weight: 2,
      },
    ],
    weight: 1,
  },
  {
    id: 'item2',
    label: CHARITY_ITEM_NAME,
    userStatistics: [
      {
        metricDesc: 'travels_total_spends',
        value: '52002.35',
        weight: 3,
      },
      {
        metricDesc: 'favorite_travel_company',
        value: 'Аэрофлот',
        weight: 4,
      },
    ],
    bonuses: [
      {
        id: 'bonus4',
        weight: 1,
      },
      {
        id: 'bonus1',
        weight: 2,
      },
      {
        id: 'bonus8',
        weight: 3,
      },
    ],
    weight: 2,
  },
  {
    id: 'item3',
    label: 'sport',
    userStatistics: [
      {
        metricDesc: 'gym_total_quantity',
        value: '150050',
        weight: 5,
      },
      {
        metricDesc: 'gym_total_spends',
        value: '3230001.25',
        weight: 6,
      },
      {
        metricDesc: 'gym_average_visits',
        value: '24',
        weight: 7,
      },
    ],
    bonuses: [
      {
        id: 'bonus5',
        weight: 1,
      },
      {
        id: 'bonus8',
        weight: 2,
      },
    ],
    weight: 3,
  },
  {
    id: 'item4',
    label: 'mobile',
    userStatistics: [
      {
        metricDesc: 'mobile_average_call_duration',
        value: '5131231',
        weight: 8,
      },
      {
        metricDesc: 'amt_2025_tran_amt',
        value: '20.25',
        weight: 9,
      },
      {
        metricDesc: 'amt_2025_tran_dt',
        value: '2024-11-19T09:57:04.874Z',
        weight: 9,
      },
      {
        metricDesc: 'min_spend_tran_amt_rur',
        value: '0.12',
        weight: 10,
      },
      {
        metricDesc: 'mb_sec',
        value: '23040',
        weight: 8,
      },
    ],
    bonuses: [],
    weight: 4,
  },
  {
    id: 'item5',
    label: 'food',
    userStatistics: [
      {
        metricDesc: 'favorite_food',
        value: 'колбаса',
        weight: 9,
      },
      {
        metricDesc: 'favorite_drink',
        value: 'квас',
        weight: 10,
      },
    ],
    bonuses: [
      {
        id: 'bonus7',
        weight: 1,
      },
      {
        id: 'bonus8',
        weight: 2,
      },
    ],
    weight: 5,
  },
];

export const mockNotificationsError = new HttpErrorProject('Notifications error', {
  httpCode: 422,
  errorCode: ErrorCode.UserNotificationsToggleError,
  errorMessage: 'something went wrong',
  timestamp: '2024-10-10T00:00:00.000Z',
  requestId: 'afdfdf-sdfef33-fdfdfewf33-dvdfvdfv',
});

export const mockIsOpenedAllItemsError = new HttpErrorProject('Update isOpenedAllItems error', {
  httpCode: 422,
  errorCode: ErrorCode.UserIsOpenedAllItemsToggleError,
  errorMessage: 'something went wrong',
  timestamp: '2024-10-10T00:00:00.000Z',
  requestId: 'afdfdf-sdfef33-fdfdfewf33-dvdfvdfv',
});

export const mockOnboardingError = new HttpErrorProject('Onboarding error', {
  httpCode: 422,
  errorCode: ErrorCode.UserOnboardingFinishError,
  errorMessage: 'something went wrong',
  timestamp: '2024-10-10T00:00:00.000Z',
  requestId: 'afdfdf-sdfef33-fdfdfewf33-dvdfvdfv',
});

export const mockOpenItemError = new HttpErrorProject('Open item error', {
  httpCode: 422,
  errorCode: ErrorCode.UserItemOpenError,
  errorMessage: 'something went wrong',
  timestamp: '2024-10-10T00:00:00.000Z',
  requestId: 'afdfdf-sdfef33-fdfdfewf33-dvdfvdfv',
});

export const mockOpenBonusError = new HttpErrorProject('Open bonus error', {
  httpCode: 422,
  errorCode: ErrorCode.UserItemBonusOpenError,
  errorMessage: 'something went wrong',
  timestamp: '2024-10-10T00:00:00.000Z',
  requestId: 'afdfdf-sdfef33-fdfdfewf33-dvdfvdfv',
});
